const PublicInformationInquiryMge = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/PublicInformationInquiryMge')), 'PublicInformationInquiryMge');
// const PropertyProjectInformationInquiryList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/PropertyProjectInformationInquiry/PropertyProjectInformationInquiryList')), 'PropertyProjectInformationInquiryList');
const InformationInquiryPropertyEnterprisesList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/InformationInquiryPropertyEnterprises/InformationInquiryPropertyEnterprisesList')), 'InformationInquiryPropertyEnterprisesList');
// const EmployeeInformationInquiryList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/EmployeeInformationInquiry/EmployeeInformationInquiryList')), 'EmployeeInformationInquiryList');
const SystemUserInformationInquiryList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/SystemUserInformationInquiry/SystemUserInformationInquiryList')), 'SystemUserInformationInquiryList');
const NeighborhoodCommunityInquiriesList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/NeighborhoodCommunityInquiries/NeighborhoodCommunityInquiriesList')), 'NeighborhoodCommunityInquiriesList');
const EmployeeDetailInformation = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/EmployeeInformationInquiry/EmployeeDetailInformation')), 'EmployeeDetailInformation');
// const InformationDetailPropertyEnterprisesList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/InformationInquiryPropertyEnterprises/InformationDetailPropertyEnterprisesList')), 'InformationDetailPropertyEnterprisesList');
// const PropertyProjectInformationDetailList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/PropertyProjectInformationInquiry/PropertyProjectInformationDetailList')), 'PropertyProjectInformationDetailList');
// const businessDocSearch = r => require.ensure([], () => r(require('@/page/businessDocSearch/businessDocSearch')), 'businessDocSearch');
const PropertyProjectManagerList = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/PropertyProjectManager/PropertyProjectManagerList')), 'PropertyProjectManagerList');
// const PropertyProjectManagerDetails = r => require.ensure([], () => r(require('@/page/PublicInformationInquiry/PropertyProjectManager/PropertyProjectManagerDetails')), 'PropertyProjectManagerDetails');

const PersonalCenterRouter = {
  path: '',
  component: PublicInformationInquiryMge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '公共信息查询',
  redirect: '/PropertyProjectInformationInquiryList',
  children: [
    //   {
    //   path: '/PropertyProjectInformationInquiryList',
    //   component: PropertyProjectInformationInquiryList,
    //   name: '物业项目信息查询',
    //   meta: {
    //     name: '物业项目信息查询',
    //     right: ['物业项目信息查询'],
    //     isShowMenu: true
    //   },
    // },
    {
      path: '/InformationInquiryPropertyEnterprisesList',
      component: InformationInquiryPropertyEnterprisesList,
      name: '物业企业信息查询',
      meta: {
        name: '物业企业信息查询',
        right: ['物业企业信息查询'],
        isShowMenu: true
      },
    },
    // {
    //   path: '/EmployeeInformationInquiryList',
    //   component: EmployeeInformationInquiryList,
    //   name: '从业人员信息查询',
    //   meta: {
    //     name: '从业人员信息查询',
    //     right: ['从业人员信息查询'],
    //     isShowMenu: true
    //   },
    // },
    {
      path: '/SystemUserInformationInquiryList',
      component: SystemUserInformationInquiryList,
      name: '系统用户信息查询',
      meta: {
        name: '系统用户信息查询',
        right: ['系统用户信息查询'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/NeighborhoodCommunityInquiriesList',
      component: NeighborhoodCommunityInquiriesList,
      name: '辖区街道社区查询',
      meta: {
        name: '辖区街道社区查询',
        right: ['辖区街道社区查询'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/PropertyProjectManagerList',
      component: PropertyProjectManagerList,
      name: '物业项目负责人查询',
      meta: {
        name: '物业项目负责人查询',
        right: ['物业项目负责人查询'],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/EmployeeDetailInformation',
      component: EmployeeDetailInformation,
      name: '物业从业人员详情',
      meta: {
        name: '物业从业人员详情',
        right: ['物业从业人员详情'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    // {
    //   path: '/InformationDetailPropertyEnterprisesList',
    //   component: InformationDetailPropertyEnterprisesList,
    //   name: '物业企业详情',
    //   meta: {
    //     name: '物业企业详情',
    //     right: ['物业企业详情'],
    //     isShowMenu: false
    //   },
    // },
    // {
    //   path: '/PropertyProjectInformationDetailList',
    //   component: PropertyProjectInformationDetailList,
    //   name: '小区项目详情',
    //   meta: {
    //     name: '小区项目详情',
    //     right: ['小区项目详情'],
    //     isShowMenu: false
    //   },
    // },
    // {
    //   path: '/PropertyProjectManagerDetails',
    //   component: PropertyProjectManagerDetails,
    //   name: '物业项目负责人详情',
    //   meta: {
    //     name: '物业项目负责人详情',
    //     right: ['物业项目负责人详情'],
    //     isShowMenu: false
    //   },
    // },
    // {
    //   path: '/businessDocSearch',
    //   component: businessDocSearch,
    //   name: '业务单查询',
    //   meta: {
    //     name: '业务单查询',
    //     right: ['业务单查询'],
    //     isShowMenu: false
    //   },
    // },
  ]
};

export default PersonalCenterRouter;